import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function urlValidator(): ValidatorFn {
    const urlRegex = /^(https?:\/\/)([\w-]+(\.[\w-]+)+)(:[0-9]{1,5})?(\/[^\s]*)?$/i;

    return (control: AbstractControl): ValidationErrors | null => {
        const value: string = control.value?.trim();

        if (!value) {
            return null;
        }

        const isValid = urlRegex.test(value);

        return isValid ? null : { invalidUrl: true };
    };
}
